import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik, Form } from 'formik';
import { validate, defaultSchema, formatMobile } from '../../../lib/validation';
import { request } from '../../../lib/apiRequestWrapper';
import Button from '../../../audi-ui-components/Button';
import FormField from '../../../components/FormField';
import UploadField from '../../../components/UploadField';
import Tooltip from '../../../components/Tooltip';
import LoadingOverlay from '../../../components/LoadingOverlay';
import IconForward from '../../../audi-ui-components/icons/Forward';
import { gtmPush } from '../../../lib/gtm';
import { FIELD_DEALER_SELECT, FIELD_DATEPICKER, FIELD_RADIOS, FIELD_SELECT, OPTS_STATES } from '../../../constants';
import _find from 'lodash/find';
import moment from 'moment';
import VINHelp from '../components/VINHelp';
import CollapsibleSection from '../../../components/CollapsibleSection';

const mapStateToProps = state => {
  return {
    isLoadingProfile: state.profile.isLoading,
    profile: state.profile.data ? state.profile.data : {},
  };
};

const RegisterVehicleForm = ({ profile, isLoadingProfile }) => {
  
  const [isLoadingDealers, setIsLoadingDealers] = useState(false);
  const [isLoadingVehicle, setIsLoadingVehicle] = useState(false);
  const [isLoadingImg, setIsLoadingImg] = useState(false);

  const [dealers, setDealers] = useState([]);
  const [dealersError, setDealersError] = useState(null);
  const [dealerId, setDealerId] = useState("");
  const [files, setFiles] = useState(null);
  const [serverError, setServerError] = useState(null);
  const [fileError, setFileError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [step, setStep] = useState(1);
  const [vehicle, setVehicle] = useState({});
  const [vinImg, setVinImg] = useState(null);
  
  const fetchDealers = () => {
    request(
      process.env.RAZZLE_GQLAPI,
      {
        method: "POST",
        body: JSON.stringify({
          query: /* GraphQL */`query ($skip: Int, $sort: LocationDtoSortInput!, $filter: LocationDtoFilterInput) {
            locationList(skip: $skip, take: 50, order: [$sort], where: $filter) {
              items {
                id name state
                dealer {
                  dealerCode dealerId name
                }
              }
              totalCount
            }
          }`,
          variables: {
            skip: 0,
            sort: {name: "ASC"},
            filter: {type: {eq: "Sales"}, status: {eq: true}}
          }
        })
      }
    ).then(response => {
      // console.log(response);
      let items = response.data?.locationList?.items;
      if (items?.length > 0) {
        setDealers(items);
        let selected = _find(items, function(o) { return o.dealer?.name === profile.preferredDealer; });
        if (selected?.dealer?.dealerId) { setDealerId(selected.dealer.dealerId); }
      } else {
        let msg = "We couldn't find any dealers";
        setDealersError(msg);
      }
      setIsLoadingDealers(false);
    }).catch(err => {
      // console.log(err);
      let msg = "We couldn't find any dealers";
      setDealersError(msg);
      setIsLoadingDealers(false);
    });
  }

  const handleSubmit = (values, formikBag) => {
    setServerError(null);
    setFileError(null);
    let fd = new FormData();
    fd.append('file', files[0]);
    request(
      `${process.env.RAZZLE_API}/1/request/uploadImage`,
      {
        method: 'POST',
        body: fd,
        headers: {
          'Cache-Control': 'no-cache'
        },
      }
    ).then(response => {
      // console.log(response);

      // submit form data
      let dos = moment(values.saleDate).format("YYYY/MM/DD");
      let _data = Object.assign({}, values, {saleDate: dos, RegistrationImageUrl: response});
      if (!_data.modelName) {
        _data.modelName = vehicle.vehicleData?.model || vehicle.vehicleData?.modelDescription;
      }
      request(
        `${process.env.RAZZLE_API}/1/request/registerVehicle`,
        {
          method: 'POST',
          body: JSON.stringify(_data),
        }
      ).then(response => {
        // success
        formikBag.setSubmitting(false);
        setSubmitted(true);
        gtmPush("form", "submitSuccess", "addVehicleMyAudi", values);
      }).catch(error => {
        // error
        formikBag.setSubmitting(false);
        if (error.body && error.body.modelState) {
          let errors = {};
          for (let key in error.body.modelState) {
            if (!Object.hasOwnProperty(key)) {
              errors[key] = error.body.modelState[key][0];
            }
          }
          formikBag.setStatus(errors);
        } else if (error.message) {
          setServerError(error.message);
        } else if (error.body && error.body.message) {
          setServerError(error.body.message);
        }
      });
      // end submit form data

    }).catch(error => {
      formikBag.setSubmitting(false);
      if (error.body && error.body.message) {
        setFileError(error.body.message);
      }
    });

  }

  const onSubmitVin = (values, errors, setFieldValue, setFieldTouched) => {
    setServerError(null);
    if (values.vin && !errors.vin) {
      lookupVin(values.vin, values, setFieldValue, setFieldTouched);
    } else if (values.registrationNumber && values.regoState) {
      lookupRego(values, setFieldValue, setFieldTouched);
    } else {
      setFieldTouched('vin');
      setFieldTouched('registrationNumber');
      setFieldTouched('regoState');
    }
  };
  const lookupVin = (vin, values, setFieldValue, setFieldTouched) => {
    setIsLoadingVehicle(true);
    request(
      `${process.env.RAZZLE_API}/2/services/vehicle/${vin}`,
      {
        method: 'POST',
      }
    ).then(response => {
      // success
      if (response.vin) {
        if (!values.vin) {
          setFieldValue("vin", vin);
        }
        if (!values.registrationNumber) {
          setFieldValue("registrationNumber", response.rego);
          setFieldValue("regoState", response.state);
        }
        setFieldTouched('vin');
        setFieldTouched('registrationNumber');
        setFieldTouched('regoState');
        setVehicle(response);
        setIsLoadingVehicle(false);
        setStep(2);
      } else {
        console.log(response);
        setServerError("We couldn't find that vehicle");
        setIsLoadingVehicle(false);
      }
    }).catch(error => {
      // error
      console.log(error);
      setServerError("We couldn't find that vehicle");
      setIsLoadingVehicle(false);
    });
  }
  const lookupRego = (values, setFieldValue, setFieldTouched) => {
    setIsLoadingVehicle(true);
    request(
      `${process.env.RAZZLE_API}/2/services/vehicle/${values.registrationNumber}/${values.regoState}`,
      {
        method: 'POST',
      }
    ).then(response => {
      // success
      if (response.vin) {
        lookupVin(response.vin, values, setFieldValue, setFieldTouched);
      } else {
        setIsLoadingVehicle(false);
        setServerError("We can't find a matching Audi VIN with the registration number you have entered. Please try entering the VIN directly.");
      }
    }).catch(error => {
      // error
      console.log(error);
      setServerError("We can't find a matching Audi VIN with the registration number you have entered. Please try entering the VIN directly.");
      setIsLoadingVehicle(false);
    });
  }

  const validateForm = (values) => {
    let validation = validate(values, {
      firstName: defaultSchema.firstName,
      lastName: defaultSchema.lastName,
      emailAddress: defaultSchema.email,
      postcode: defaultSchema.postcode,
      mobilePhone: defaultSchema.mobile,
      registrationNumber: {
        presence: { message: "Please enter the vehicle registration number", allowEmpty: false }
      },
      regoState: {
        presence: { message: "Please select the vehicle registration state", allowEmpty: false }
      },
      vin: defaultSchema.vin,
      saleDate: {
        presence: { message: "Please select the date", allowEmpty: false },
        isPastDate: true
      },
    }, { format: "firstError", fullMessages: true }) || {};
    if (values.saleType === 'audi' && !values.dealerId) {
      validation.dealerId = "Please select a dealer";
    }
    if (values.saleType === 'other' && !values.otherText) {
      validation.otherText = "Please provide details";
    }
    if (!files || files.length === 0) {
      validation.file = "This field is required";
    }
    return validation;
  }
  
  useEffect(() => {
    if (!dealers || dealers.length === 0) {
      fetchDealers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (vehicle.vin) {
      setIsLoadingImg(true);
      request(
        `${process.env.RAZZLE_MEDIASERVICE}/MediaServiceCache?vin=${vehicle.vin}&view=n3c14aut&mimeType=image/png&wid=400`,
        {}
      ).then((res) => {
        // console.log(res);
        setVinImg(res.imageUrl);
        setIsLoadingImg(false);
      }).catch((error) => {
        setIsLoadingImg(false);
      });
    } else {
      setVinImg(null);
    }
  }, [vehicle.vin]);

  return (
    <div className="cvo">

      {submitted &&
        <div>
          <h2 className="aui-headline-4 mb-7">Thank you</h2>
          <p>Thank you for submitting your registration request. Audi Customer Care will contact you and confirm when we have processed your registration change.</p>
        </div>
      }

      {!submitted && <Formik
        initialValues={{
          firstName: profile.firstName,
          lastName: profile.lastName,
          emailAddress: profile.email,
          mobilePhone: profile.mobile,
          postcode: profile.homePostcode,
          vin: "",
          modelName: "",
          saleType: "audi",
          dealerId: dealerId
        }}
        enableReinitialize
        validate={validateForm}
        onSubmit={handleSubmit}>
        {formikBag => (
          <Form>
            {formikBag.isSubmitting && <LoadingOverlay />}

            {vehicle?.vin && step !== 1 && <div className="vehicle mb-7">
              <div>
                <p className="vehicle-heading">Your Audi</p>
                <p><b>{vehicle.vehicleAge?.yearOfManufacturer !== 0 && vehicle.vehicleAge?.yearOfManufacturer} {vehicle.vehicleData?.make || vehicle.vehicleData?.makeDescription} {vehicle.vehicleData?.model || vehicle.vehicleData.modelDescription}</b></p>
                <p>{vehicle.rego} ({vehicle.state})</p>
                <p>{vehicle.vin}</p>
              </div>
              <div className="vehicle-img">
                {vinImg && !isLoadingImg && <img src={vinImg} alt="" />}
                {isLoadingImg && <LoadingOverlay />}
              </div>
            </div>}

            {step === 1 && <div>
              <div className="aui-color-gray95 p-5 mb-5">
                <CollapsibleSection visibleContent={(<p className="aui-headline-5">Where to find your Vehicle Identification Number (VIN)</p>)} toggleOnClickVisible>
                  <VINHelp />
                </CollapsibleSection>
              </div>
              <FormField name="vin" label="VIN" formikBag={formikBag} />
              <div className="or aui-headline-5"><span>OR</span></div>
              <FormField name="registrationNumber" label="Registration" formikBag={formikBag} />
              <FormField name="regoState" label="Registration state" fieldType={FIELD_SELECT} options={OPTS_STATES} formikBag={formikBag} />
              <br />
              {serverError && <p className="mb-5 aui-color-text-red">{serverError}</p>}
              <p className="mt-4">
                <Button
                  variant="primary"
                  label="Next"
                  icon={<IconForward small />}
                  iconPosition="right"
                  onClick={() => {
                    onSubmitVin(formikBag.values, formikBag.errors, formikBag.setFieldValue, formikBag.setFieldTouched);
                  }}
                  disabled={isLoadingVehicle} />
              </p>
            </div>}

            {step === 2 && <div>
              {(!profile.firstName || !profile.lastName) && <>
                <FormField name="firstName" label="First name" formikBag={formikBag} />
                <FormField name="lastName" label="Last name" formikBag={formikBag} />
              </>}
              {(!profile.mobile || formikBag.errors.mobilePhone) && <FormField name="mobilePhone" label="Mobile phone" formikBag={formikBag} formatValue={formatMobile} />}
              {(!profile.homePostcode || formikBag.errors.postcode) && <FormField name="postcode" label="Postcode" formikBag={formikBag} />}

              <p className="mb-3">
                Please upload your vehicle proof of purchase or vehicle registration papers.
                <br />
                <Tooltip
                  trigger={<span className="aui-textlink">Why we need your registration papers?</span>}
                  tip="We are unable to legally record you as the owner of this vehicle without proof of ownership."
                />
              </p>
              <UploadField
                accept=".jpg,.jpeg,.png,.gif,.pdf"
                onChange={f => { setFiles(f); setFileError(null); formikBag.setFieldTouched("file"); }}
                isInvalid={Boolean(fileError || (formikBag.errors.file && (formikBag.touched.file || formikBag.submitCount > 0)))}
                invalidMessage={fileError || formikBag.errors.file}
              />

              <FormField name="saleType" label="How did you purchase this vehicle?" fieldType={FIELD_RADIOS} formikBag={formikBag} wrapperClassName="mt-6 mb-2" options={[
                {name: 'saleType', label: 'Audi Dealer', value: 'audi'},
                {name: 'saleType', label: 'Other', value: 'other'}
              ]} />
              {formikBag.values.saleType === 'audi' &&
                <FormField name="dealerId"
                  label="Dealer"
                  fieldType={FIELD_DEALER_SELECT}
                  dealers={dealers || []}
                  valueProp="dealer.dealerId"
                  formikBag={formikBag}
                  description={isLoadingDealers ? "Loading..." : ""}
                />
              }
              {formikBag.values.saleType === 'other' &&
                <FormField name="otherText" label="Please specify" description="eg. 'private purchase' or name of dealership" formikBag={formikBag} />
              }

              <FormField name="saleDate" label="Date of purchase" fieldType={FIELD_DATEPICKER} formikBag={formikBag} />

              <br />
              {serverError && <p className="mb-5 aui-color-text-red">{serverError}</p>}
              <p className="mt-4">
                <Button
                  variant="primary"
                  label="Add vehicle"
                  icon={<IconForward small />}
                  iconPosition="right"
                  type="submit"
                  disabled={formikBag.isSubmitting} />
              </p>
            </div>}
          </Form>
        )}
      </Formik>}
    </div>
  );
}

export default connect(mapStateToProps)(RegisterVehicleForm);
